import axios from 'axios';
import { IDispatcherResult } from '@/catalog-search/Scripts/Validation';
import { SearchType } from './ISearchService';

export interface IRequestProgramInfo {
	programId: string;
	emailAddress: string;
	name: string;
	note: string;
}

export interface IRequestCourseInfo {
	courseId: string;
	emailAddress: string;
	name: string;
	note: string;
}

export interface ISendFavorites {
	searchType: SearchType;
	ids: string[];
	emailAddress: string;
	query: string;
	note: string;
}

export interface ISendService {
	sendProgramRequest(rmi: IRequestProgramInfo): Promise<IDispatcherResult>;
	sendCourseRequest (rmi: IRequestCourseInfo): Promise<IDispatcherResult>;
	sendFavorites (data: ISendFavorites): Promise<IDispatcherResult>;
}

export class SendService implements ISendService {
	public async sendProgramRequest (data: IRequestProgramInfo): Promise<IDispatcherResult> {
		const response = await axios({
			method: 'post',
			url: '/CatalogSearch/RequestProgramInfo',
			data
		});

		return response.data;
	}

	public async sendCourseRequest (data: IRequestCourseInfo): Promise<IDispatcherResult> {
		const response = await axios({
			method: 'post',
			url: '/CatalogSearch/RequestCourseInfo',
			data
		});

		return response.data;
	}

	public async sendFavorites (data: ISendFavorites): Promise<IDispatcherResult> {
		const entity = SearchType[data.searchType];

		const url = `/CatalogSearch/Send${entity}s`;

		const response = await axios({
			method: 'post',
			url,
			data
		});

		return response.data;
	}
}
